import React from 'react';
import './Footer.css';
import { NavLink } from 'react-router-dom';
import { FaFacebookF, FaInstagram, FaYoutube } from 'react-icons/fa';

const Footer = ({ userForDomain }) => {
 const year = new Date().getFullYear();
 const theme = userForDomain?.theme || 'light';
 const slug = userForDomain?.slug;
 const hostname = window.location.hostname;
 const mainDomain = "sportinghip.com";
 const isLocalhost = hostname === "localhost";
 const isCustomDomain = !isLocalhost && hostname !== mainDomain && hostname !== "www.sportinghip.com";
 const fallbackSlug = window.location.pathname.split("/")[1];
 const basePath = isCustomDomain ? "" : `/${slug || fallbackSlug || ""}`;
console.log(userForDomain)
 return (
  <footer className={`footer_container ${theme}-theme`}>
   {/* 🔼 Social icons go above main footer row */}
   <div className="footer_socials">
    {userForDomain?.facebook_url && (
     <a href={userForDomain.facebook_url} target="_blank" rel="noopener noreferrer">
      <FaFacebookF />
     </a>
    )}
    {userForDomain?.instagram_url && (
     <a href={userForDomain.instagram_url} target="_blank" rel="noopener noreferrer">
      <FaInstagram />
     </a>
    )}
    {userForDomain?.youtube_url && (
     <a href={userForDomain.youtube_url} target="_blank" rel="noopener noreferrer">
      <FaYoutube />
     </a>
    )}
   </div>


   {/* 👇 Main footer row */}
   <div className="footer_main">
    <div className="footer_left">
     <p>
      Site Powered by{' '}
      <a href="https://sportinghip.com" target="_blank" rel="noreferrer">
       SportingHip.com
      </a>
     </p>
    </div>

    <div className="footer_center">
     <p>© {year} {userForDomain?.slug?.toUpperCase() || "LEAGUE"}. All rights reserved.</p>
    </div>

    <div className="footer_right">
     <NavLink to={`${basePath}/login`} className="admin_link">
      Admin Sign In <span style={{ fontSize: '0.6rem', marginLeft: '4px' }}>▶</span>
     </NavLink>
    </div>
   </div>
  </footer>

 );
};

export default Footer;
